import { render, staticRenderFns } from "./AutosView.vue?vue&type=template&id=2b8e4147&scoped=true"
import script from "./AutosView.vue?vue&type=script&lang=js"
export * from "./AutosView.vue?vue&type=script&lang=js"
import style0 from "./AutosView.vue?vue&type=style&index=0&id=2b8e4147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e4147",
  null
  
)

export default component.exports